import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getQueryParam } from 'config/helpers';

import { Heading, Link, Button, Paragraph } from 'components';

import withNewsletter from '../HOC';
import NewsletterSuccess from '../Success';

import './NewsletterRegular.scss';

class NewsletterRegular extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subscribed: '',
      newsletter: false,
    };
  }

  componentDidMount() {
    this.checkSubscription();
    this.checkLocation();
  }

  checkSubscription() {
    this.setState({
      subscribed: this.props.subscribed || getQueryParam('subscribed'),
    });
  }

  checkLocation() {
    this.setState({
      newsletter: window.location.pathname === '/newsletter/',
    });
  }

  render() {
    const { refForm, handleSubmit, short } = this.props;
    const { subscribed, newsletter: newsletterLanding } = this.state;


    return (
      <div className={'newsletter'}>
        <div>
          <Paragraph
            size={'small'}
            additionalClass={'newsletter__label text--bold'}
          >
            Newsletter
          </Paragraph>
          <Heading size={'big'} type={1} additionalClass={'newsletter__headline'}>
            {subscribed ? (
              <>
                Thank you
                <br />
                for subscribing!
                <NewsletterSuccess />
              </>
            ) : (
              <>
                <span className={'newsletter__headline--short'}>Subscribe </span>
                <span className={'newsletter__headline--short'}>
                  to Digital Shift{' '}
                </span>
                <span className={'newsletter__headline--long'}>Newsletter</span>
              </>
            )}
          </Heading>
          {short && (
            <Paragraph
              additionalClass={`newsletter__lead text--light ${subscribed &&
                'newsletter--hidden'}`}
            >
              Get an inspirational insight into the practical application of a
              radically user-oriented design and disruptive software services
              shaping the digital economy 4.0, selected by co-CEOs of Boldare.
            </Paragraph>
          )}
          <Paragraph
            additionalClass={`newsletter__lead text--light ${!subscribed &&
              'newsletter--hidden'} newsletter__headline--long`}
          >
            {'Soon we’ll send you an welcome e-mail, meantime check our website.'}
          </Paragraph>
        </div>
        {subscribed && (
          <Link to={'/'} additionalClass={'newsletter__headline--long'}>
            <Button id={'newsletter-go-home'} color={'transparent'}>
              Go to homepage
            </Button>
          </Link>
        )}
        <form
          className={`js-newsletter newsletter__form ${
            subscribed ? 'newsletter--hidden' : ''
          }`}
          onSubmit={handleSubmit}
          ref={refForm}
        >
          {newsletterLanding && (
            <>
              <input
                type={'text'}
                name={'name'}
                placeholder={'Name'}
                className={'newsletter_additional-input'}
                required
              />
              <input
                type={'text'}
                name={'surname'}
                placeholder={'Surname'}
                className={'newsletter_additional-input'}
                required
              />
            </>
          )}
          <input
            type={'email'}
            name={'email'}
            placeholder={'E-mail'}
            required
          />
          <Paragraph additionalClass={'newsletter__info text--light'}>
            {
              "We're committed to your privacy. Boldare uses the information you provide to us to contact you about our relevant content, products, and services. "
            }
            {'Read our '}
            <Link to={'/privacy-policy/'} id={'newsletter-privacy-policy'}>
              privacy policy.
            </Link>
          </Paragraph>
          <Button
            id={'newsletter-submit-regular'}
            type={'submit'}
            color={'transparent'}
          >
            Subscribe
          </Button>
        </form>
      </div>
    );
  }
}

NewsletterRegular.propTypes = {
  subscribed: PropTypes.bool.isRequired,
  refForm: PropTypes.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  short: PropTypes.bool,
};

NewsletterRegular.defaultProps = {
  short: false,
};

export default withNewsletter(NewsletterRegular);
